import { createContext } from 'react';
import { PinataClient } from '@pinata/sdk';

export interface PinataContext {
  client: PinataClient;
  apiKey: string;
  apiSecret: string;
}

const Context = createContext<PinataContext>(null as never);

export default Context;
